export const selectSearchHub = (state) => state.searchHub;
